import { render, staticRenderFns } from "./tableCadastralOvamVlaremAct.vue?vue&type=template&id=3e5a7564&scoped=true"
import script from "./tableCadastralOvamVlaremAct.vue?vue&type=script&lang=js"
export * from "./tableCadastralOvamVlaremAct.vue?vue&type=script&lang=js"
import style0 from "./tableCadastralOvamVlaremAct.vue?vue&type=style&index=0&id=3e5a7564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5a7564",
  null
  
)

export default component.exports